import { useContext, useEffect, useState } from "react"
import { switchh } from "../../context/switch"
import { config } from "../../context/config";
import { auth } from "../../context/auth";
import { isOnline } from "../../funcs/isOnline";
import { action } from "../../context/action";
import { ServerRunning } from "../../funcs/serverRunning";
import { deleteDatabase } from "../indexDB/indexDBStora";

export default function ResetCodeHolder () {

    const timeOut = 180;

    const { setEnableSendResetCode, loadingProcess, setLoadingProcess } = useContext(switchh);
    const { api } = useContext(config);
    const { setErrorMessage, errorMessage } = useContext(action);
    const { ActivEmp } = useContext(auth)

    const [OTPR, setOTPR] = useState('');
    const [timeOutSendAgain, setTimeOutSendAgain] = useState(timeOut);

    const [isRunTimeOut, setIsRunTimeOut] = useState({
        iSent: false,
        message: ""
    });

    const Reset = () => {
        setOTPR("")
        setEnableSendResetCode(false);
    }

    useEffect(() => {

        const getOTP = async () => {

            setLoadingProcess(true);

            if(!isOnline()) {
                setErrorMessage("لا يوجد أتصال بالأنترنت حاليا");
                setLoadingProcess(false);
                return;
            }

            const statusServer = await ServerRunning();

            if(!statusServer) {
                setLoadingProcess(false);
                setErrorMessage("نعتذر جدا على العطل الحالي .. حاول في وقت لاحق");
                return;
            }

            setErrorMessage("");

            if(!ActivEmp?.name) {
                setErrorMessage("يرجى اعادة تسجيل الدخول مره اخرى");
                setLoadingProcess(false);
                return;
            };

            try {

                const res = await fetch(`${api}/otp/sentOtpResetCode`, {
                    method: "POST",
                    headers: {
                        "Content-Type":"application/json",
                    },
                    cache: "no-store",
                    credentials: "include",
                    body: JSON.stringify({ user: ActivEmp.name })
                });

                const result = await res.json();

                setIsRunTimeOut({
                    iSent: result.status,
                    message: result.message
                });

                if(result.status){
                    setTimeOutSendAgain(timeOut);
                }

            }
            catch(error) {
                setIsRunTimeOut({
                    iSent:false,
                    message:""
                });
                setErrorMessage("حدث خطأ ما");
                console.log("error ->", error);
            }
            finally {
                setLoadingProcess(false);
            }

        };

        getOTP();

    }, []);


    useEffect(() => {

        if(!isRunTimeOut.iSent) return;

        if(timeOutSendAgain <= 0) return;

        const timer = setTimeout(() => {
            setTimeOutSendAgain((prev) => prev - 1);
        }, 1000);

        return () => clearTimeout(timer);

    }, [timeOutSendAgain, isRunTimeOut.iSent]);

    
    const verifyOTPReset = async (e) => {
    e.preventDefault();

    const trimmedOTP = OTPR.trim();

    if(!/^\d{6}$/.test(trimmedOTP)) {
        setErrorMessage("ادخل كود التحقق بشكل صحيح");
        return;
    }
    
    if(!isOnline()) {
        setErrorMessage("لا يوجد اتصال بالأنترنت");
        return;
    }

    setErrorMessage("");
    setLoadingProcess(true);
    try {
        const res = await fetch(`${api}/otp/verifyOtpResetCode`, {
            method: "POST",
            headers: {
                "Content-Type":"application/json",
            },
            credentials: "include",
            body: JSON.stringify({ otp: trimmedOTP })
        });

        const result = await res.json();

        if(result.status) {
           await deleteDatabase();
           window.location.pathname = '/';
        } else {
            setErrorMessage(result.message);
        }

    } catch (error) {
        console.error("Error verifying OTP:", error);
        setErrorMessage("حدث خطأ ما أثناء التحقق");
    }
    finally {
        setLoadingProcess(false);
    }
}

    return (
        <div className="access-container container-box fixed flex flex-center-center">
            <div className="box center">

                <button onClick={Reset} disabled={loadingProcess} className='close'>x</button>

                {loadingProcess ?

                    <p>جار التحميل ...</p>

                :

                <div className="content">

                    <h3>رمز التأكيد (OTP)</h3>

                    <p>
                        لكي يتم التعيين من جديد لإعادة ضبط المصنع يرجى ادخال الكود الذي أرسل الى البريد الألكتروني الخاص بالمالك
                    </p>

                    {isRunTimeOut.iSent ?
                        <p className="warning-bg-v2 button-">
                            يمكن اعادة طلب الكود بعد {timeOutSendAgain} ثانية
                        </p>
                        :
                        <p className="warning-bg-v2 button-">{isRunTimeOut.message}</p>

                    }
                    <form onSubmit={verifyOTPReset}>
                        <input 
                            onChange={(e) => {
                                const value = e.target.value.replace(/[^0-9]/g, '');
                                setOTPR(value)
                            }}
                            type="text"
                            value={OTPR}
                            maxLength={6}
                            placeholder="* * * * * *"
                        />

                        <button className="button-zone">تأكيد</button>
                    </form>

                </div>

                }

                <p className="error">{errorMessage}</p>

            </div>
        </div>
    )
}